import React from "react";

const PlayIcon = ({ fill }) => {
  return (
    <svg
      className=" cursor-pointer w-7 h-7 shrink-0 -ml-2"
      id="start"
      xmlns="http://www.w3.org/2000/svg"
      width="32.908"
      height="38.216"
      viewBox="0 0 32.908 38.216"
    >
      <g
        id="Polygon_8"
        data-name="Polygon 8"
        transform="translate(0 38.216) rotate(-90)"
        fill="none"
      >
        <path
          d="M16.514,4.468a3,3,0,0,1,5.189,0L35.6,28.4a3,3,0,0,1-2.594,4.506H5.211A3,3,0,0,1,2.617,28.4Z"
          stroke="none"
        />
        <path
          d="M 19.1080493927002 4.97447395324707 C 18.93494987487793 4.97447395324707 18.50416946411133 5.022985458374023 18.24325942993164 5.472345352172852 L 4.346199035644531 29.40617370605469 C 4.084171295166016 29.85744476318359 4.257610321044922 30.25658416748047 4.344348907470703 30.40723419189453 C 4.431079864501953 30.55789566040039 4.68914794921875 30.90830421447754 5.210990905761719 30.90830421447754 L 33.00510787963867 30.90830421447754 C 33.52695083618164 30.90830421447754 33.78501892089844 30.55789566040039 33.87174987792969 30.40723419189453 C 33.95848846435547 30.25658416748047 34.13192749023438 29.85744476318359 33.86989974975586 29.40617370605469 L 19.97282981872559 5.472333908081055 C 19.7119197845459 5.022985458374023 19.28114891052246 4.97447395324707 19.1080493927002 4.97447395324707 M 19.10804748535156 2.974479675292969 C 20.11614990234375 2.974479675292969 21.12424850463867 3.472345352172852 21.7024097442627 4.468074798583984 L 35.59947967529297 28.40190505981445 C 36.76075744628906 30.40189552307129 35.31779861450195 32.90830612182617 33.00510787963867 32.90830612182617 L 5.210990905761719 32.90830612182617 C 2.898300170898438 32.90830612182617 1.455337524414062 30.40189552307129 2.616619110107422 28.40190505981445 L 16.51367950439453 4.468074798583984 C 17.09184455871582 3.472345352172852 18.09994697570801 2.974479675292969 19.10804748535156 2.974479675292969 Z"
          stroke="none"
          fill={`${fill ? fill : "#000"}`}
        />
      </g>
    </svg>
  );
};

export default PlayIcon;
